/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PropertyTypeEnum = 1 | 2 | 3 | 4 | 5;

export const PropertyTypeEnum = {
    NUMBER_1: 1 as PropertyTypeEnum,
    NUMBER_2: 2 as PropertyTypeEnum,
    NUMBER_3: 3 as PropertyTypeEnum,
    NUMBER_4: 4 as PropertyTypeEnum,
    NUMBER_5: 5 as PropertyTypeEnum
};

